import { Col, Row } from "react-bootstrap";
import FcCarousel from "../FcCarousel/FcCarousel";
import CardGrupo from "../Card Grupos/CardGrupo";

interface CardCarouselProps {
  items: any[];
  preCarga?: boolean;
}

export default function InfiniteCard({ items, preCarga = false }: CardCarouselProps) {
  function chunkArray(array: any[], size: number) {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  }

  const grupos = chunkArray(items, 12);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "2rem" }}>
      {grupos.map((grupo, index) => (
        <Row key={index}>
          <FcCarousel
            items={grupo.map((articuloGrupo: any) => (
              <Col xs={6} sm={3} xl={2} xxl={2} lg={3} md={3} key={articuloGrupo.articuloGrupoId}>
                <CardGrupo 
                  articuloGrupo={articuloGrupo} 
                  preCarga={preCarga}
                />
              </Col>
            ))}
          />
        </Row>
      ))}
    </div>
  );
}